import React, { useEffect } from "react";
import { Table, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getVillaBookings, resetState } from "../features/VillaBooking/VillaBookingSlice.js";

const VillaBookingList = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetState());
        dispatch(getVillaBookings());
    }, [dispatch]);

    const bookingList =
        useSelector((state) => state.villaBooking.VillaBookings) || [];

    console.log("Villa Bookings:", bookingList);

    // ---------------- Columns ----------------
    const columns = [
        {
            title: "S.No",
            dataIndex: "key",
            width: 70,
        },
        {
            title: "Booking ID",
            dataIndex: "bookingId",
        },
        {
            title: "Customer Name",
            dataIndex: "name",
        },
        {
            title: "Email",
            dataIndex: "email",
        },
        {
            title: "Mobile",
            dataIndex: "mobile",
        },
        {
            title: "Amount",
            dataIndex: "amount",
        },
        {
            title: "Payment ID",
            dataIndex: "paymentId",
        },
        {
            title: "Status",
            dataIndex: "status",
        },
        {
            title: "API Booking ID",
            dataIndex: "apiBookingId",
        },
        {
            title: "Error",
            dataIndex: "error",
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
        },
    ];

    // ---------------- Data Mapping ----------------
    const dataSource = bookingList.map((item, index) => ({
        key: index + 1,

        bookingId: item?.bookingId || "—",

        // Guest Details
        name: `${item?.requestPayload?.guest?.firstName || ""} ${item?.requestPayload?.guest?.lastName || ""}` || "—",
        email: item?.requestPayload?.guest?.email || "—",
        mobile: item?.requestPayload?.guest?.phone || "—",

        // Payment
        amount: `₹ ${item?.requestPayload?.payment?.amount || 0}`,
        paymentId: item?.requestPayload?.payment?.transactionId || "—",

        // Status Tag
        status:
            item?.status === "SUCCESS" ? (
                <Tag color="green">SUCCESS</Tag>
            ) : item?.status === "FAILED" ? (
                <Tag color="red">FAILED</Tag>
            ) : (
                <Tag>{item?.status}</Tag>
            ),

        // API Response
        apiBookingId: item?.responsePayload?.bookingId || "—",

        // Error
        error: item?.error ? (
            <Tag color="red">{item.error}</Tag>
        ) : (
            "—"
        ),

        // Date
        createdAt: item?.createdAt
            ? new Date(item.createdAt).toLocaleString()
            : "—",
    }));

    return (
        <div>
            <h3 className="mb-4 title">Villa Booking List</h3>

            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                pagination={{ pageSize: 10 }}
                scroll={{ x: 1200 }}
            />
        </div>
    );
};

export default VillaBookingList;